import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import routesName from "../../constants/routesName";
import useDisplayToggle from "../../utils/useDisplayToggle";
import { useAppDispatch } from "../../redux/store";
import { getHospitalById } from "../../redux/addHospital/hospitalManagementReducer";
import successToast from "../../utils/successToast";
import errorToast from "../../utils/errorToast";
import { LoadingSpinner } from "../../components/ui/loadinSpinner";
import { LinkIcon, MailOutlineIcons, MoreOptionIcon, PersonIcon, PhoneEnabledIcons } from "../../components/muiIconsImport";
import StatusWithColor from "../../utils/StatusWithColor";
import { removeBedSize } from "../../helper";
import { BootstrapTooltip } from "../../utils/toolTip";
import ConfirmationModal from "../../components/modals/confirmationModal";
import LogoutIcon from "../../assests/icons/logoutIcon.svg";
import { resetLinkHospitalToAccManagerState } from "../../redux/accountManager/accountManagerSlice";
import AccountManagerViewAllModal from "../../components/hospitalManagement/accountManagerViewAllModal";
import DeleteIcon from "../../assests/icons/deleteIcon.png";
import useAxios from "../../hooks/useAxios";
import { hospitalApi } from "../../jsonData/apiPathData/hospital";
import AdminIcon from "../../assests/icons/adminIcon.svg";
import enums from "../../constants/enums";
import LinkAccountManagerModal from "../../components/hospitalManagement/linkAccountMangerModal";
import DefaultImage from "../../assests/images/defaultImage.svg";
import { AccessTokenDecoder, AsyncAccessTokenDecoder } from "../../utils/accessTokenDecoder";
import axios from "axios";
import UserAuditDetails from "../../utils/userAuditDetails";
import DetectDevice from "../../utils/detectDevice";
import { SelectedUserData } from "./hospitalManagement/tableBody";
import ForgotPasswordHospital from "./ForgotPasswordHospital";
import dayjs from "dayjs";

const HospiatDetailsCard = ({ hospitalBasicInfo, managementInfo, accountManagerInfo, hospitalAdminInfo, params, hospitalInfo }: any) => {
  const userDetails = AccessTokenDecoder();
  const [showOptions, setShowOptions] = useState(false);
  const [delinkModal, setDelinkModal] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [accManagerModal, setAccManagerModal] = useState(false);
  const [linkAccManagerModal, setLinkAccManagerModal] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);
  const decodeToken = AsyncAccessTokenDecoder();

  const [selectedUserData, setSelectedUserData] = useState<SelectedUserData>(
    {}
  );
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const editHospitalFn = () => {
    navigate(`${routesName.hospitalManagementPage}/edit-hospital-info/${params?.id}`);
  };

  const resetHospitalFn = () => {
    navigate(`${routesName.hospitalManagementPage}/edit-hospital-info/${params?.id}`, {
      state: { action: "resetPassword" },
    });
  };

  useEffect(() => {
    return () => {
      dispatch(resetLinkHospitalToAccManagerState());
    };
  }, []);

  const onClickRef = useRef(null);
  const insideClickRef = useRef(null);
  useDisplayToggle({
    onClickRef,
    insideClickRef,
    setDisplay: setShowOptions,
  });

  // delink account manager axios call
  const {
    data: delinkSuccess,
    error: delinkError,
    loading: delinkLoading,
    postFn: delinkFn,
    toggle: delinkToggle,
  } = useAxios({
    method: "post",
    path: `${hospitalApi.delinkAccountManger}userid=${hospitalBasicInfo?.accountManager?.userId}&isToBeLinked=0`,
    body: [params?.id],
  });

  useEffect(() => {
    if (delinkSuccess?.success) {
      setDelinkModal(false);
      dispatch(getHospitalById(params?.id));
      successToast("Delinked Successfully");
    } else if (delinkError) {
      errorToast("Something Went Wrong");
    }
  }, [delinkSuccess, delinkError, delinkToggle]);

  const viewAllAccountManagerFn = () => {
    setAccManagerModal(true);
  };
  const [isLoading, setIsLoading] = useState(false);
  // hospital delete axios call
  const {
    data: deleteHospitalSuccess,
    error: deleteHospitalError,
    loading: deleteLoading,
    deleteFn: deleteHospital,
    toggle,
  } = useAxios({
    method: "delete",
    path: `${hospitalApi.deleteHos}${params?.id}`,
  });

  const { osVersion, operatingSystem, ipAddress } = UserAuditDetails();
  const deviceType = DetectDevice();


  useEffect(() => {
    const deleteMA = async () => {
      if (deleteHospitalSuccess?.success) {
        successToast("Hospital deleted successfully");

        if (params?.id) {
          try {
            const url = process.env.REACT_APP_MA_DEACTIVATE_HOSPITAL_URL || "";
            const token = sessionStorage.getItem("newlogin");

            const headers = {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            };

            // IMPORTANT: body must be an object
            const hospitalId = params?.id

            const maResponse = await axios.get(url, {
              headers,
              params: { hospitalId }
            });
            console.log("MA API Response:", maResponse.data);
          } catch (err: any) {
            console.error("MA API Error:", err);
            errorToast("MA Assistant API failed");
          }
        }
        navigate(routesName.hospitalManagementPage);
      } else if (deleteHospitalError) {
        errorToast("Something Went Wrong");
      }
    }
    deleteMA();
  }, [deleteHospitalSuccess, deleteHospitalError, toggle]);

  // console.log(hospitalBasicInfo, hospitalAdminInfo, "hospitalBasicInfohospitalBasicInfo");
  const userDetailsCopy = AccessTokenDecoder();
  // console.log(userDetailsCopy, accountManagerInfo);
  console.log(userDetailsCopy, 'accountManagerInfo');
  const isManagementUser = userDetailsCopy?.Roles === enums.Management || userDetailsCopy?.Roles === enums.SuperAdmin;
  const isAccountManager = isManagementUser || (userDetailsCopy?.userId == accountManagerInfo?.userId);
  const redirectMAApp = async () => {
    setIsLoading(true);
    const url = process.env.REACT_APP_MA_LOGIN_NEW_URL || "";
    const mapUrl = process.env.REACT_APP_MA_MAP_HOSPITAL_URL || "";
    const data = JSON.parse(sessionStorage.getItem("maLoginCredentials") || "{}");
    const headersMapUser = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("newlogin")} `, // Add token here
    };
    const headers = {
      accept: "*/*",
      "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
    };

    axios
      .post(
        mapUrl,
        {
          email: userDetailsCopy?.email,
          hospitalId: hospitalBasicInfo?.hospitalId,
          accountManagerId: userDetailsCopy?.userId,
        },
        { headers: headersMapUser, params }
      )
      .then(async () => {
        const response = await axios.post(url, {
          ...data, hospitalid: hospitalBasicInfo?.hospitalId,
          appSourceType: "Management Assistant",
          moduleType: "login",
          os: operatingSystem,
          ipAddress: ipAddress,
          imeiNumber: "",
          osVersion: osVersion,
          macAddress: "",
          model: "",
          userAction: "Login",
          device: deviceType,
        }, { headers });

        if (response.data) {
          setIsLoading(false);
          window.open(`${process.env.REACT_APP_MA_APP_REFERRAL_URL}?token=${response?.data?.access_token}&refresh=${response?.data?.refresh_token}&hospitalid=${hospitalBasicInfo?.hospitalId}`, "_blank");
          console.log(`${process.env.REACT_APP_MA_APP_REFERRAL_URL}?token=${response?.data?.access_token}&refresh=${response?.data?.refresh_token}&hospitalid=${hospitalBasicInfo?.hospitalId}`, "_blank");
        } else {
          setIsLoading(false);
          errorToast("Something went wrong");
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        errorToast("Something went wrong");
      });
  };
  const resetHospitalManagementFn = (data: {
    name: string;
    hospitalId?: string;
    photo?: string;
    email?: string;
    id?: number;
    userName?: string;
    phone?: string | undefined;
    role?: string;
  }) => {
    setSelectedUserData(data);
    setResetPassword((prev: boolean) => !prev);
  };

  const productAndPlanInfo = hospitalInfo?.productandPlanInfos?.[0]?.planInfo;

  const validityStart = productAndPlanInfo?.validityStart;

  const validityEnd = productAndPlanInfo?.validityEnd;

  // console.log(productAndPlanInfo, validityStart, validityEnd, 'productAndPlanInfo');

  const isValidityActive = useMemo(() => {
    if (!validityStart || !validityEnd) return false;

    const now = dayjs();
    const start = dayjs(validityStart).startOf("day");
    const end = dayjs(validityEnd).endOf("day");

    return !now.isBefore(start) && !now.isAfter(end);
  }, [validityStart, validityEnd]);

  const isValidityPastOneMonthBeforeExpiry = useMemo(() => {
    if (!validityEnd) return false;

    const today = dayjs().startOf("day");
    const end = dayjs(validityEnd).startOf("day");
    const diffInDays = end.diff(today, "day");
    // return true only if expiry is within the next 0-30 days
    return diffInDays >= 0 && diffInDays <= 31;
  }, [validityEnd]);

  // console.log(isValidityActive, isValidityPastOneMonthBeforeExpiry, "validity status");
  return (
    <>
      <ForgotPasswordHospital
        isVisible={resetPassword}
        onClick={() => { }}
        onClose={() => {
          setResetPassword(false);
        }}
        data={{
          name: selectedUserData?.name ?? "",
          hospitalId: selectedUserData?.hospitalId ?? "",
          photo: selectedUserData?.photo ?? "",
          email: selectedUserData?.email ?? "",
          phone: selectedUserData?.phone ?? "",
          // userId: selectedUserData?.id,
          userName: selectedUserData?.userName,
          // role: selectedUserData?.role,
        }}
      />
      <ConfirmationModal
        isVisible={isDeleteModal}
        onClose={() => {
          setIsDeleteModal(false);
        }}
        onClick={() => {
          deleteHospital();
        }}
        icon={DeleteIcon}
        title={`Are you sure you want to Delete this Hospital?`}
        description="Please note that you will not be able to recover these later."
        actionText={"Delete"}
        isLoading={deleteLoading}
      />
      <AccountManagerViewAllModal isVisible={accManagerModal} onClose={() => setAccManagerModal(false)} managementInfo={managementInfo} accountManagerInfo={accountManagerInfo} hospitalAdminInfo={hospitalAdminInfo} />
      <LinkAccountManagerModal isVisible={linkAccManagerModal} onClose={() => setLinkAccManagerModal(false)} />
      <ConfirmationModal isVisible={delinkModal} onClose={() => setDelinkModal(false)} onClick={() => delinkFn()} actionText={"De-Link"} title={"Are you sure you want to de-link the account manager? "} icon={LogoutIcon} isLoading={delinkLoading} />
      <div className="rounded-lg shadow-sm1 bg-white relative">
        <div className="grid grid-cols-12 items-center p-6">
          <div className="lg:col-span-1 col-span-2">
            <img src={hospitalBasicInfo?.logoURL ? hospitalBasicInfo?.logoURL : DefaultImage} height={"100px"} width={"100px"} className="rounded-full shadow-ex1" />
          </div>
          <div className="lg:col-span-11 col-span-10 w-full px-3 ">
            <div className="flex justify-between">
              <div>
                <span className="text-20 font-semibold text-primary">{hospitalBasicInfo?.name}</span>
                <span className="ps-4">
                  <StatusWithColor value={hospitalBasicInfo?.status === enums.inactive ? enums?.deactivated : hospitalBasicInfo?.status} />
                </span>
              </div>
              <div className="absolute top-5 right-5 flex items-center gap-5">
                <div className="py-1">
                  {/* {isValidityPastOneMonthBeforeExpiry && <button>Renew</button>} */}

                  <button
                    onClick={redirectMAApp}
                    disabled={!isAccountManager || isLoading || hospitalBasicInfo?.status === enums?.inactive}
                    title={isAccountManager || hospitalBasicInfo?.status !== enums?.inactive ? "Click here to login to MA Assistant app" : "You are not allowed to access this hospital"}
                    style={{
                      cursor: !isAccountManager || hospitalBasicInfo?.status === enums?.inactive ? "not-allowed" : undefined,
                    }}
                    className={`flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 
    ${!isAccountManager || hospitalBasicInfo?.status === enums?.inactive ? "bg-gray-200 text-gray-400 border border-gray-300" : "bg-blue-600 hover:bg-blue-700 text-blue-300 border border-blue-600 hover:shadow-md"}
    ${isLoading ? "opacity-80 cursor-wait" : ""}
  `}
                  >
                    {isLoading ? (
                      <>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" className="text-blue-300 animate-spin" viewBox="0 0 1024 1024"><path fill="currentColor" d="M600.704 64a32 32 0 0 1 30.464 22.208l35.2 109.376c14.784 7.232 28.928 15.36 42.432 24.512l112.384-24.192a32 32 0 0 1 34.432 15.36L944.32 364.8a32 32 0 0 1-4.032 37.504l-77.12 85.12a357.12 357.12 0 0 1 0 49.024l77.12 85.248a32 32 0 0 1 4.032 37.504l-88.704 153.6a32 32 0 0 1-34.432 15.296L708.8 803.904c-13.44 9.088-27.648 17.28-42.368 24.512l-35.264 109.376A32 32 0 0 1 600.704 960H423.296a32 32 0 0 1-30.464-22.208L357.696 828.48a351.616 351.616 0 0 1-42.56-24.64l-112.32 24.256a32 32 0 0 1-34.432-15.36L79.68 659.2a32 32 0 0 1 4.032-37.504l77.12-85.248a357.12 357.12 0 0 1 0-48.896l-77.12-85.248A32 32 0 0 1 79.68 364.8l88.704-153.6a32 32 0 0 1 34.432-15.296l112.32 24.256c13.568-9.152 27.776-17.408 42.56-24.64l35.2-109.312A32 32 0 0 1 423.232 64H600.64zm-23.424 64H446.72l-36.352 113.088-24.512 11.968a294.113 294.113 0 0 0-34.816 20.096l-22.656 15.36-116.224-25.088-65.28 113.152 79.68 88.192-1.92 27.136a293.12 293.12 0 0 0 0 40.192l1.92 27.136-79.808 88.192 65.344 113.152 116.224-25.024 22.656 15.296a294.113 294.113 0 0 0 34.816 20.096l24.512 11.968L446.72 896h130.688l36.48-113.152 24.448-11.904a288.282 288.282 0 0 0 34.752-20.096l22.592-15.296 116.288 25.024 65.28-113.152-79.744-88.192 1.92-27.136a293.12 293.12 0 0 0 0-40.256l-1.92-27.136 79.808-88.128-65.344-113.152-116.288 24.96-22.592-15.232a287.616 287.616 0 0 0-34.752-20.096l-24.448-11.904L577.344 128zM512 320a192 192 0 1 1 0 384 192 192 0 0 1 0-384zm0 64a128 128 0 1 0 0 256 128 128 0 0 0 0-256z" /></svg>
                        <span>Please wait...</span>
                      </>
                    ) : (
                      <>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" className="text-blue-300" viewBox="0 0 1024 1024"><path fill="currentColor" d="M600.704 64a32 32 0 0 1 30.464 22.208l35.2 109.376c14.784 7.232 28.928 15.36 42.432 24.512l112.384-24.192a32 32 0 0 1 34.432 15.36L944.32 364.8a32 32 0 0 1-4.032 37.504l-77.12 85.12a357.12 357.12 0 0 1 0 49.024l77.12 85.248a32 32 0 0 1 4.032 37.504l-88.704 153.6a32 32 0 0 1-34.432 15.296L708.8 803.904c-13.44 9.088-27.648 17.28-42.368 24.512l-35.264 109.376A32 32 0 0 1 600.704 960H423.296a32 32 0 0 1-30.464-22.208L357.696 828.48a351.616 351.616 0 0 1-42.56-24.64l-112.32 24.256a32 32 0 0 1-34.432-15.36L79.68 659.2a32 32 0 0 1 4.032-37.504l77.12-85.248a357.12 357.12 0 0 1 0-48.896l-77.12-85.248A32 32 0 0 1 79.68 364.8l88.704-153.6a32 32 0 0 1 34.432-15.296l112.32 24.256c13.568-9.152 27.776-17.408 42.56-24.64l35.2-109.312A32 32 0 0 1 423.232 64H600.64zm-23.424 64H446.72l-36.352 113.088-24.512 11.968a294.113 294.113 0 0 0-34.816 20.096l-22.656 15.36-116.224-25.088-65.28 113.152 79.68 88.192-1.92 27.136a293.12 293.12 0 0 0 0 40.192l1.92 27.136-79.808 88.192 65.344 113.152 116.224-25.024 22.656 15.296a294.113 294.113 0 0 0 34.816 20.096l24.512 11.968L446.72 896h130.688l36.48-113.152 24.448-11.904a288.282 288.282 0 0 0 34.752-20.096l22.592-15.296 116.288 25.024 65.28-113.152-79.744-88.192 1.92-27.136a293.12 293.12 0 0 0 0-40.256l-1.92-27.136 79.808-88.128-65.344-113.152-116.288 24.96-22.592-15.232a287.616 287.616 0 0 0-34.752-20.096l-24.448-11.904L577.344 128zM512 320a192 192 0 1 1 0 384 192 192 0 0 1 0-384zm0 64a128 128 0 1 0 0 256 128 128 0 0 0 0-256z" /></svg>
                        <span>Set-up Hospital</span>
                      </>
                    )}
                  </button>
                </div>
                <button className="text-blue-300 w-[24px] h-[24px]" ref={onClickRef} onClick={() => setShowOptions(!showOptions)}>
                  <MoreOptionIcon />
                </button>

              </div>
            </div>

            {showOptions && (
              <div className="absolute top-10 right-12 flex flex-col  shadow-lg rounded-lg bg-white whitespace-nowrap" ref={insideClickRef}>
                <button
                  className="p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold  rounded-t-lg"
                  type="button"
                  onClick={() => {
                    editHospitalFn();
                  }}
                >
                  Edit
                </button>
                {decodeToken?.Roles !== "Admin" && < button
                  className="p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold"
                  type="button"
                  onClick={() => {
                    resetHospitalManagementFn({
                      name: hospitalBasicInfo?.name,
                      hospitalId: hospitalBasicInfo?.code,
                      photo: hospitalBasicInfo?.logoURL || "",
                      email: hospitalAdminInfo?.email,
                      // id: item?.userId,
                      phone: hospitalAdminInfo?.phone
                      // userName: hos?.hospitalInfo?.name,
                      // role: item?.role,
                    })
                  }}
                >
                  Reset Password
                </button>}
                {decodeToken?.Roles !== "Admin" && <button
                  className="p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold rounded-b-lg"
                  type="button"
                  onClick={() => {
                    setIsDeleteModal(true);
                  }}
                >
                  {deleteLoading ? <LoadingSpinner /> : "Delete"}
                </button>}
              </div>
            )}
            <div className="flex overflow-x-auto scroll_bar whitespace-nowrap pt-3">
              <span className="border-r-2 pe-2">
                <span className="font-normal text-14 text-secondary">ID : </span>

                <span className="font-semibold text-14 text-primary">{hospitalBasicInfo?.code}</span>
              </span>
              <span className="border-r-2 px-2">
                <span className="font-normal text-14 text-secondary">Location : </span>
                <span className="font-semibold text-14 text-primary">{hospitalBasicInfo?.city}</span>
              </span>
              <span className="border-r-2 px-2">
                <span className="font-normal text-14 text-secondary">Speciality : </span>
                {hospitalBasicInfo?.speciality?.slice(0, 2).map((item: any, index: number) => (
                  <span className="font-semibold text-14 text-primary" key={index}>
                    {item?.name} {hospitalBasicInfo?.speciality?.length - 1 !== index ? "," : ""}
                  </span>
                ))}
                {hospitalBasicInfo?.speciality?.length > 2 && (
                  <BootstrapTooltip
                    title={
                      <div className="p-1">
                        {hospitalBasicInfo?.speciality?.map((ser: any, index: number) => (
                          <div className="text-secondary p-0.5 text-14 font-medium flex items-center gap-2" key={index}>
                            <span className="text-18">&#x2022;</span>
                            {ser?.name}
                          </div>
                        ))}
                      </div>
                    }
                    placement="top"
                  >
                    <span className="text-blue-300 text-14 font-semibold cursor-pointer">+ {hospitalBasicInfo.speciality.length - 2} more</span>
                  </BootstrapTooltip>
                )}
              </span>
              <span className="px-2">
                <span className="font-normal text-14 text-secondary">Bed Size : </span>
                <span className="font-semibold text-14 text-primary">{removeBedSize(hospitalBasicInfo?.bedSize)}</span>
              </span>
            </div>
          </div>
        </div>

        <div className="rounded-b-xl bg-blue-150">
          <div className="grid lg:grid-cols-2 gap-4 p-6">
            <div className="lg:border-r-2 flex flex-col gap-4 overflow-x-auto scroll_bar">
              <div className="flex justify-between pe-3">
                <span className="font-semibold text-18 text-primary">Hospital Management</span>
                <button className="text-blue-300 text-14 font-bold" type="button" onClick={() => viewAllAccountManagerFn()}>
                  View All
                </button>
              </div>
              <div className="flex items-center overflow-x-auto scroll_bar whitespace-nowrap text-secondary text-14 font-medium">
                <span className="border-r-2 pe-2 flex items-center gap-2 ">
                  <PersonIcon />
                  {managementInfo?.[0]?.name}
                </span>
                <span className="border-r-2 px-2 flex items-center gap-2">
                  <PhoneEnabledIcons />
                  +91 {managementInfo?.[0]?.phone}
                </span>
                <span className="px-2 flex items-center gap-2">
                  <MailOutlineIcons />
                  {managementInfo?.[0]?.email}
                </span>
              </div>
            </div>
            {/* {accountManagerInfo?.name && ( */}
            <div className="flex flex-col gap-4 overflow-x-auto scroll_bar">
              <div className="flex justify-between ">
                <span className="font-semibold text-18 text-primary">Account Manager</span>
                {accountManagerInfo?.name ? (
                  <button
                    className={`${userDetails?.Roles === enums.Admin ? "text-disabled" : "text-blue-300"} text-14 font-bold flex items-center gap-2`}
                    type="button"
                    onClick={() => setDelinkModal(true)}
                    disabled={userDetails?.Roles === enums.Admin}
                  >
                    <LinkIcon /> Delink Manager
                  </button>
                ) : (
                  <button
                    className={`${userDetails?.Roles === enums.Admin ? "text-disabled" : "text-blue-300"} text-14 font-bold flex items-center gap-2`}
                    type="button"
                    onClick={() => setLinkAccManagerModal(true)}
                    disabled={userDetails?.Roles === enums.Admin}
                  >
                    <LinkIcon /> Link Manager
                  </button>
                )}
              </div>
              <div className="flex items-center overflow-x-auto scroll_bar whitespace-nowrap text-secondary text-14 font-medium">
                <span className="border-r-2 pe-2 flex items-center gap-2 ">
                  <PersonIcon />
                  {accountManagerInfo?.name}
                </span>
                <span className="border-r-2 px-2 flex items-center gap-2">
                  <img src={AdminIcon} />
                  {accountManagerInfo?.roleName}
                </span>
                <span className="px-2 flex items-center gap-2">
                  <PhoneEnabledIcons />
                  +91 {accountManagerInfo?.phone}
                </span>
              </div>
            </div>
            {/* )} */}
          </div>
        </div>
      </div >
    </>
  );
};

export default HospiatDetailsCard;
